import React from "react";
import { useImmer } from "use-immer";
import {
  PersonalDataType,
  UserImage,
  EducationType,
  SelectBlockOption,
  RewardType,
  WorkExperienceType,
  Language,
} from "../../types";
import { capitalize } from "../utils";

export interface StoreState {
  activeTemplate: number;
  personalData: PersonalDataType;
  userImage: UserImage;
  educationEditIndex: number | null;
  tempEducation: EducationType;
  education: EducationType[];
  tempExperience: string;
  experience: SelectBlockOption[];
  rewardEditIndex: number | null;
  tempReward: RewardType;
  reward: RewardType[];
  workExperienceEditIndex: number | null;
  tempWorkExperience: WorkExperienceType;
  workExperience: WorkExperienceType[];
  tempSkill: string;
  skills: SelectBlockOption[];
  languages: Language[];
  about: string;
  tempLanguage: string;
  tempCourse: string;
  courses: SelectBlockOption[];
  palette: number;
}

export interface StoreFunctions {
  setActiveTemplate(template: StoreState["activeTemplate"]): void;
  setPersonalData(key: keyof PersonalDataType, value: string): void;
  setUserImage(image: UserImage["image"]): void;
  setTempEducation(key: keyof EducationType, value: string): void;
  addEducation(): void;
  editEducation(index: number): void;
  removeEducation(index: number): void;
  toggleExperience(index: number): void;
  setTempExperience(value: string): void;
  addExperience(): void;
  setTempReward(key: keyof RewardType, value: string): void;
  addReward(): void;
  editReward(index: number): void;
  removeReward(index: number): void;
  setTempWorkExperience(key: keyof WorkExperienceType, value: string): void;
  addWorkExperience(): void;
  editWorkExperience(index: number): void;
  removeWorkExperience(index: number): void;
  setTempSkill(value: string): void;
  toggleSkill(index: number): void;
  addSkill(): void;
  toggleLanguage(index: number): void;
  setLanguageValue(index: number, value: number): void;
  setTempLanguage(value: string): void;
  addLanguage(): void;
  setAbout(value: string): void;
  toggleCourse(index: number): void;
  setTempCourse(value: string): void;
  addCourse(): void;
  setPalette(value: number): void;
}

export interface StoreProps {
  children: React.ReactNode;
}

export const initialPersonalData: PersonalDataType = {
  name: "",
  lastName: "",
  street: "",
  city: "",
  postal: "",
  phone: "",
  email: "",
};

export const initialTempEducation: EducationType = {
  name: "",
  address: "",
  title: "",
  profile: "",
  year: "",
};

export const initialTempReward: RewardType = {
  name: "",
  company: "",
  description: "",
  date: "",
};

export const initialTempWorkExperience: WorkExperienceType = {
  role: "",
  company: "",
  description: "",
  dateStart: "",
  dateEnd: "",
};

export const initialStoreState: StoreState = {
  activeTemplate: 1,
  personalData: initialPersonalData,
  userImage: {
    image: null,
  },
  educationEditIndex: null,
  tempEducation: initialTempEducation,
  education: [],
  tempExperience: "",
  experience: [
    {
      name: "Praca w wolontariatach ",
      active: false,
    },
    {
      name: "Aktywność w samorządzie uczniowskim",
      active: false,
    },
    {
      name: "Teatr amatorski ",
      active: false,
    },
    {
      name: "Organizacja eventów kulturalnych",
      active: false,
    },
    {
      name: "Organizacja eventów sportowych ",
      active: false,
    },
    {
      name: "Organizacja wycieczek ",
      active: false,
    },
    {
      name: "Uczestnictwo w olimpiadach naukowych ",
      active: false,
    },
  ],
  rewardEditIndex: null,
  tempReward: initialTempReward,
  reward: [],
  workExperienceEditIndex: null,
  tempWorkExperience: initialTempWorkExperience,
  workExperience: [],
  tempSkill: "",
  skills: [
    {
      name: "Zdolności organizacyjne",
      active: false,
    },
    {
      name: "Umiejętność pracy w zespole",
      active: false,
    },
    {
      name: "Łatwość nawiązywania kontaktów",
      active: false,
    },
    {
      name: "Rozwiązywanie konfliktów",
      active: false,
    },
    {
      name: "Umiejętności negocjacyjne",
      active: false,
    },
    {
      name: "Logiczne myślenie",
      active: false,
    },
    {
      name: "Skrupulatność",
      active: false,
    },
    {
      name: "Niestandardowe rozwiązania",
      active: false,
    },
    {
      name: "Obsługa pakietu Microsoft Office",
      active: false,
    },
    {
      name: "Obsługa programów graficznych",
      active: false,
    },
  ],
  tempLanguage: "",
  languages: [
    {
      name: "Angielski",
      active: false,
      value: 0,
    },
    {
      name: "Niemiecki",
      active: false,
      value: 0,
    },
    {
      name: "Hiszpański",
      active: false,
      value: 0,
    },
    {
      name: "Francuski",
      active: false,
      value: 0,
    },
  ],
  about: "",
  tempCourse: "",
  courses: [],
  palette: 0,
};

// export const initialStoreState: StoreState = {
//   activeTemplate: 2,
//   personalData: {
//     name: "Ewelina",
//     lastName: "Ferdzyn-Walak",
//     street: "marchołta 3/38",
//     city: "Kraków",
//     postal: "31-416",
//     phone: "123-123-444",
//     email: "anna.bankowska@gmail.com",
//   },
//   userImage: {
//     image: null,
//   },
//   educationEditIndex: null,
//   tempEducation: initialTempEducation,
//   education: [
//     {
//       name: "Gimnazjum nr 3",
//       address: "Radom",
//       title: "Inżynier",
//       profile: "matematyczno-informatyczna",
//       year: "2012",
//     },
//   ],
//   experience: [
//     {
//       name: "Praca w wolontariatach ",
//       active: true,
//     },
//     {
//       name: "aktywność w samorządzie uczniowskim",
//       active: true,
//     },
//     {
//       name: "teatr amatorski ",
//       active: false,
//     },
//     {
//       name: "Organizacja eventów kulturalnych",
//       active: true,
//     },
//     {
//       name: "Organizacja eventów sportowych ",
//       active: false,
//     },
//     {
//       name: "Organizacja wycieczek ",
//       active: false,
//     },
//     {
//       name: "Uczestnictwo w olimpiadach naukowych ",
//       active: false,
//     },
//   ],
//   rewardEditIndex: null,
//   tempReward: initialTempReward,
//   reward: [
//     {
//       name: "Nagroda",
//       company: "Google",
//       description: "Za coś tam dostałem",
//       date: "09.2020",
//     },
//     {
//       name: "Kolejna nagroda",
//       company: "Facebook",
//       description: "Za coś tam dostałem",
//       date: "09.2020",
//     },
//   ],
//   workExperienceEditIndex: null,
//   tempWorkExperience: initialTempWorkExperience,
//   workExperience: [
//     {
//       role: "Rola",
//       company: "Firma",
//       description: "Lorem ipsum sdf s d sfdff sdfsdf ",
//       dateStart: "08.2020",
//       dateEnd: "10.2020",
//     },
//     {
//       role: "Kierownik wszystkiego",
//       company: "Szczecin",
//       description: "",
//       dateStart: "08.2020",
//       dateEnd: "10.2020",
//     },
//   ],
//   tempSkill: "",
//   skills: [
//     {
//       name: "Zdolności organizacyjne",
//       active: true,
//     },
//     {
//       name: "Umiejętność pracy w zespole",
//       active: false,
//     },
//     {
//       name: "Łatwość nawiązywania kontaktów",
//       active: false,
//     },
//     {
//       name: "Rozwiązywanie konfliktów",
//       active: true,
//     },
//     {
//       name: "Umiejętności negocjacyjne",
//       active: false,
//     },
//     {
//       name: "Logiczne myślenie",
//       active: false,
//     },
//     {
//       name: "Skrupulatność",
//       active: true,
//     },
//     {
//       name: "Niestandardowe rozwiązania",
//       active: false,
//     },
//     {
//       name: "Obsługa pakietu Microsoft Office",
//       active: false,
//     },
//     {
//       name: "Obsługa programów graficznych",
//       active: false,
//     },
//   ],
//   tempLanguage: "",
//   languages: [
//     {
//       name: "Angielski",
//       active: true,
//       value: 4,
//     },
//     {
//       name: "Niemiecki",
//       active: true,
//       value: 2,
//     },
//     {
//       name: "Hiszpański",
//       active: false,
//       value: 0,
//     },
//     {
//       name: "Francuski",
//       active: false,
//       value: 0,
//     },
//   ],
//   about:
//     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspend  isse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.",
//   tempCourse: "",
//   courses: [
//     { name: "Obsługa terminala płatniczego", active: true },
//     { name: "Mój1 kurs", active: true },
//     { name: "Mój kurs2", active: true },
//     { name: "Mój kurs3", active: true },
//   ],
//   palette: 0,
// };

const StoreContext = React.createContext<StoreState & StoreFunctions>(
  undefined!
);
const { Provider, Consumer } = StoreContext;

const StoreProvider = (props: StoreProps) => {
  const [state, updateState] = useImmer<StoreState>(() => initialStoreState);
  const setActiveTemplate: StoreFunctions["setActiveTemplate"] = (template) => {
    updateState((draft: StoreState) => {
      draft.activeTemplate = template;
    });
  };
  const setPersonalData: StoreFunctions["setPersonalData"] = (key, value) => {
    updateState((draft: StoreState) => {
      draft.personalData[key] = value;
    });
  };
  const setUserImage: StoreFunctions["setUserImage"] = (image) => {
    updateState((draft: StoreState) => {
      draft.userImage.image = image;
    });
  };
  const setTempExperience: StoreFunctions["setTempExperience"] = (value) => {
    updateState((draft: StoreState) => {
      draft.tempExperience = value;
    });
  };
  const addExperience: StoreFunctions["addExperience"] = () => {
    updateState((draft: StoreState) => {
      draft.experience.push({
        name: capitalize(draft.tempExperience),
        active: true,
      });
      draft.tempExperience = "";
    });
  };
  const toggleExperience: StoreFunctions["toggleExperience"] = (
    index: number
  ) => {
    updateState((draft: StoreState) => {
      draft.experience[index].active = !draft.experience[index].active;
    });
  };
  const setTempEducation: StoreFunctions["setTempEducation"] = (key, value) => {
    updateState((draft: StoreState) => {
      draft.tempEducation[key] = value;
    });
  };
  const addEducation: StoreFunctions["addEducation"] = () => {
    updateState((draft: StoreState) => {
      if (draft.educationEditIndex !== null) {
        draft.education[draft.educationEditIndex] = draft.tempEducation;
      } else {
        draft.education.push(draft.tempEducation);
      }
      draft.tempEducation = initialTempEducation;
      draft.educationEditIndex = null;
    });
  };
  const editEducation: StoreFunctions["editEducation"] = (index) => {
    updateState((draft: StoreState) => {
      if (index === draft.educationEditIndex) {
        draft.tempEducation = initialTempEducation;
        draft.educationEditIndex = null;
      } else {
        draft.educationEditIndex = index;
        draft.tempEducation = draft.education[index];
      }
    });
  };
  const removeEducation: StoreFunctions["editEducation"] = (index) => {
    updateState((draft: StoreState) => {
      draft.educationEditIndex = null;
      draft.education.splice(index, 1);
      draft.tempEducation = initialTempEducation;
    });
  };
  const setTempReward: StoreFunctions["setTempReward"] = (key, value) => {
    updateState((draft: StoreState) => {
      draft.tempReward[key] = value;
    });
  };
  const addReward: StoreFunctions["addReward"] = () => {
    updateState((draft: StoreState) => {
      if (draft.rewardEditIndex !== null) {
        draft.reward[draft.rewardEditIndex] = draft.tempReward;
      } else {
        draft.reward.push(draft.tempReward);
      }
      draft.tempReward = initialTempReward;
      draft.rewardEditIndex = null;
    });
  };
  const editReward: StoreFunctions["editReward"] = (index) => {
    updateState((draft: StoreState) => {
      if (index === draft.rewardEditIndex) {
        draft.tempReward = initialTempReward;
        draft.rewardEditIndex = null;
      } else {
        draft.rewardEditIndex = index;
        draft.tempReward = draft.reward[index];
      }
    });
  };
  const removeReward: StoreFunctions["editReward"] = (index) => {
    updateState((draft: StoreState) => {
      draft.rewardEditIndex = null;
      draft.reward.splice(index, 1);
      draft.tempReward = initialTempReward;
    });
  };
  const setTempWorkExperience: StoreFunctions["setTempWorkExperience"] = (
    key,
    value
  ) => {
    updateState((draft: StoreState) => {
      draft.tempWorkExperience[key] = value;
    });
  };
  const addWorkExperience: StoreFunctions["addWorkExperience"] = () => {
    updateState((draft: StoreState) => {
      if (draft.workExperienceEditIndex !== null) {
        draft.workExperience[draft.workExperienceEditIndex] =
          draft.tempWorkExperience;
      } else {
        draft.workExperience.push(draft.tempWorkExperience);
      }
      draft.tempWorkExperience = initialTempWorkExperience;
      draft.workExperienceEditIndex = null;
    });
  };
  const editWorkExperience: StoreFunctions["editWorkExperience"] = (index) => {
    updateState((draft: StoreState) => {
      if (index === draft.workExperienceEditIndex) {
        draft.tempWorkExperience = initialTempWorkExperience;
        draft.workExperienceEditIndex = null;
      } else {
        draft.workExperienceEditIndex = index;
        draft.tempWorkExperience = draft.workExperience[index];
      }
    });
  };
  const removeWorkExperience: StoreFunctions["editWorkExperience"] = (
    index
  ) => {
    updateState((draft: StoreState) => {
      draft.workExperienceEditIndex = null;
      draft.workExperience.splice(index, 1);
      draft.tempWorkExperience = initialTempWorkExperience;
    });
  };
  const setTempSkill: StoreFunctions["setTempSkill"] = (value) => {
    updateState((draft: StoreState) => {
      draft.tempSkill = value;
    });
  };
  const toggleSkill: StoreFunctions["toggleSkill"] = (index) => {
    updateState((draft: StoreState) => {
      draft.skills[index].active = !draft.skills[index].active;
    });
  };
  const addSkill: StoreFunctions["addSkill"] = () => {
    updateState((draft: StoreState) => {
      draft.skills.push({
        name: capitalize(draft.tempSkill),
        active: true,
      });
      draft.tempSkill = "";
    });
  };
  const toggleLanguage: StoreFunctions["toggleLanguage"] = (index) => {
    updateState((draft: StoreState) => {
      draft.languages[index].active = !draft.languages[index].active;
    });
  };
  const setLanguageValue: StoreFunctions["setLanguageValue"] = (
    index,
    value
  ) => {
    updateState((draft: StoreState) => {
      draft.languages[index].active = true;
      draft.languages[index].value = value;
    });
  };
  const setTempLanguage: StoreFunctions["setTempLanguage"] = (value) => {
    updateState((draft: StoreState) => {
      draft.tempLanguage = value;
    });
  };
  const addLanguage: StoreFunctions["addLanguage"] = () => {
    updateState((draft: StoreState) => {
      draft.languages.push({
        name: capitalize(draft.tempLanguage),
        active: true,
        value: 0,
      });
      draft.tempLanguage = "";
    });
  };
  const setAbout: StoreFunctions["setAbout"] = (text) => {
    updateState((draft: StoreState) => {
      draft.about = text;
    });
  };
  const toggleCourse: StoreFunctions["toggleCourse"] = (index) => {
    updateState((draft: StoreState) => {
      draft.courses[index].active = !draft.courses[index].active;
    });
  };
  const setTempCourse: StoreFunctions["setTempCourse"] = (value) => {
    updateState((draft: StoreState) => {
      draft.tempCourse = value;
    });
  };
  const addCourse: StoreFunctions["addCourse"] = () => {
    updateState((draft: StoreState) => {
      draft.courses.push({
        name: capitalize(draft.tempCourse),
        active: true,
      });
      draft.tempCourse = "";
    });
  };
  const setPalette: StoreFunctions["setPalette"] = (value) => {
    updateState((draft: StoreState) => {
      draft.palette = value;
    });
  };
  return (
    <Provider
      value={{
        ...state,
        setActiveTemplate,
        setPersonalData,
        setUserImage,
        setTempEducation,
        addEducation,
        editEducation,
        removeEducation,
        setTempExperience,
        addExperience,
        toggleExperience,
        setTempReward,
        addReward,
        editReward,
        removeReward,
        setTempWorkExperience,
        addWorkExperience,
        editWorkExperience,
        removeWorkExperience,
        setTempSkill,
        toggleSkill,
        addSkill,
        toggleLanguage,
        setLanguageValue,
        setAbout,
        setTempLanguage,
        addLanguage,
        toggleCourse,
        setTempCourse,
        addCourse,
        setPalette,
      }}
    >
      {props.children}
    </Provider>
  );
};

export { StoreProvider, Consumer as StoreConsumer, StoreContext };
